import { MonitorIcon, TabletIcon } from '@persona-id/design-tokens/icons';

import { DeviceType } from 'dashboard/models/device';
import IconIPhone from 'images/devices/iphone-se.svg';
import IconMac from 'images/devices/mac.svg';
import IconPhone from 'images/devices/phone.svg';

interface DeviceIconProps {
  deviceType: DeviceType;
  deviceName?: string;
}

const DeviceIcon = ({ deviceType, deviceName }: DeviceIconProps) => {
  // Possible device types and names are determined in back-end when populating inquiry.
  switch (deviceType) {
    case DeviceType.Desktop:
      if (deviceName === 'Mac') {
        return <IconMac />;
      } else {
        return <MonitorIcon />;
      }
    case DeviceType.Smartphone:
      if (!!deviceName && deviceName.includes('iPhone')) {
        return <IconIPhone />;
      } else {
        return <IconPhone />;
      }
    case DeviceType.Tablet:
      return <TabletIcon />;

    case DeviceType.Console:
    case DeviceType.PortableMediaPlayer:
    case DeviceType.TV:
    case DeviceType.CarBrowser:
    case DeviceType.Camera:
    default:
      return null;
  }
};

export default DeviceIcon;
